import React from "react";
import { Text, Icons, Button } from "@sede-enterprise/shell-ds-react-framework";
import { 
  ReturnsHeader as HeaderContainer, 
  ReturnsFooter as FooterContainer,
  FooterContentWrapper,
  ButtonContainer,
  FooterSpacer
} from "../Returns.styled";
import { IAuction } from "../../../services";

interface HeaderProps {
  title: string;
  onClose: () => void;
}

/**
 * Header component for the Returns panel
 */
export const ReturnsHeader: React.FC<HeaderProps> = ({ title, onClose }) => {
  return (
    <HeaderContainer>
      <Text bold={true} size="large">
        {title}
      </Text>
      <Icons.Cross className="crossIcon" onClick={onClose} />
    </HeaderContainer>
  );
};

interface FooterProps {
  hasSourceAuctions: boolean;
  onSubmitReturn: () => void;
  canSubmit: boolean;
}

/**
 * Footer component for the Returns panel with submit button
 */
export const ReturnsFooter: React.FC<FooterProps> = ({ 
  hasSourceAuctions, 
  onSubmitReturn,
  canSubmit
}) => {
  return (
    <>
      <FooterSpacer />
      <FooterContainer>
        <FooterContentWrapper>
          {hasSourceAuctions && (
            <ButtonContainer>
              <Button 
                disabled={!canSubmit}
                onClick={onSubmitReturn}
              >
                Submit Return
              </Button>
            </ButtonContainer>
          )}
        </FooterContentWrapper>
      </FooterContainer>
    </>
  );
};